import React from 'react';
import { motion } from 'framer-motion';

import './MenuToggle.scss';

const Path = ({ d, variants, transition }: any) => (
  <motion.path
    fill="transparent"
    strokeWidth="2"
    stroke="#fff"
    d={d}
    variants={variants}
    transition={transition}
  />
);

interface MenuToggleProps {
  toggle: () => void;
}

const MenuToggle = ({ toggle }: MenuToggleProps) => (
  <button
    onClick={toggle}
    className="menu-toggle"
    title="Toggle Menu"
    aria-label="Toggle Menu"
  >
    <svg width="32" height="32" viewBox="0 0 24 24">
      <Path
        variants={{
          closed: { d: 'M 2 2.5 L 20 2.5' },
          open: { d: 'M 3 16.5 L 17 2.5' },
        }}
      />
      <Path
        d="M 2 9.423 L 20 9.423"
        variants={{
          closed: { opacity: 1 },
          open: { opacity: 0 },
        }}
        transition={{ duration: 0.1 }}
      />
      <Path
        variants={{
          closed: { d: 'M 2 16.346 L 20 16.346' },
          open: { d: 'M 3 2.5 L 17 16.346' },
        }}
      />
    </svg>
  </button>
);

export default MenuToggle;
